import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import BCMustRefer from "../../BCMustRefer.js";
import ClauseCard from "../../BCLeaseClauseCard.js";
import clauseData from "../../../data/BritishColumbia/clauseData.js";
import clauseCardDesc from "../../../data/BritishColumbia/clauseCardDescription.js";
import importantNotes from "../../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";

export default function LeaseTenantListed() {
  const [TenantDocs, setTenantDocs] = useState([
    "Disclosure of Representation in Trading Services",
    "Tenant's Agency Exclusive Contract",
    "Privacy Notice & Consent Form",
    "Disclosure of Remuneration",
  ]);
  const getLandlordDocs = () => {
    const baseDocs = [
      "Disclosure of Representation in Trading Services",
      "Disclosure of Risks to Unrepresented Parties",
    ];

    return baseDocs;
  };

  const [DealDocs, setDealDocs] = useState([
    "Residential Tenancy Agreement",
    "Addendums (if applicable)",
    "Rental Application",
    "Form K (if strata)",
    "Full REALTOR® LEASED MLS Printout",
  ]);

  const [LandlordRep, setLandlordRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [TenantRep, setTenantRep] = useState("Client");
  const [CommissionPayer, setCommissionPayer] = useState("Landlord");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure("Yes");
    if (
      DealDocs.includes("Disclosure of Interest in Trade (BCFSA Form)") === true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Disclosure of Interest in Trade (BCFSA Form)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure("No");
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)"
      )
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    let newTenantDocs = [...TenantDocs];

    // Remove MLS printout and fee agreements for non-FRBO listing types
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !== "Full REALTOR® LEASED MLS Printout" &&
        item !== "Landlord's Fee Agreement" &&
        item !== "Tenant's Fee Agreement"
    );

    // Add "Disclosure of Remuneration" to tenant docs if commission payer is Landlord
    if (CommissionPayer === "Landlord" && TenantRep === "Client") {
      if (!newTenantDocs.includes("Disclosure of Remuneration")) {
        newTenantDocs.push("Disclosure of Remuneration");
      }

      // Add remuneration confirmation to deal docs for Exclusive listing with Landlord commission payer
      if (
        TenantRep === "Client" &&
        !newDealDocs.includes("Confirm Remuneration amount with LA, in writing")
      ) {
        newDealDocs.push("Confirm Remuneration amount with LA, in writing");
      }
    }

    setDealDocs(newDealDocs);
    setTenantDocs(newTenantDocs);
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    let newTenantDocs = [...TenantDocs];

    // Remove fee agreements and remuneration confirmation for non-FRBO listing types
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !== "Landlord's Fee Agreement" &&
        item !== "Tenant's Fee Agreement" &&
        item !== "Confirm Remuneration amount with LA, in writing"
    );

    // Add appropriate fee agreement for Mere Posting based on commission payer
    if (e.target.value === "Mere Posting") {
      if (CommissionPayer === "Landlord") {
        newDealDocs.push("Landlord's Fee Agreement");
      } else if (CommissionPayer === "Tenant") {
        newDealDocs.push("Tenant's Fee Agreement");
      }
    }

    // Add "Disclosure of Remuneration" to tenant docs if commission payer is Landlord
    if (CommissionPayer === "Landlord" && TenantRep === "Client") {
      if (!newTenantDocs.includes("Disclosure of Remuneration")) {
        newTenantDocs.push("Disclosure of Remuneration");
      }
    }

    if (newDealDocs.includes("Full REALTOR® LEASED MLS Printout") === true) {
      setDealDocs(newDealDocs);
      setTenantDocs(newTenantDocs);
    } else {
      setDealDocs([...newDealDocs, "Full REALTOR® LEASED MLS Printout"]);
      setTenantDocs(newTenantDocs);
    }
  };

  const handleFRBO = (e) => {
    setListingType("FRBO");
    let newDealDocs = [...DealDocs];
    let newTenantDocs = [...TenantDocs];

    // Remove "Full REALTOR® LEASED MLS Printout" for FRBO
    newDealDocs = newDealDocs.filter(
      (item) => item !== "Full REALTOR® LEASED MLS Printout"
    );
    // Remove remuneration confirmation for non-Exclusive listing types
    newDealDocs = newDealDocs.filter(
      (item) => item !== "Confirm Remuneration amount with LA, in writing"
    );

    // Add appropriate fee agreement based on commission payer for FRBO
    if (CommissionPayer === "Landlord") {
      if (!newDealDocs.includes("Landlord's Fee Agreement")) {
        newDealDocs.push("Landlord's Fee Agreement");
      }
    } else if (CommissionPayer === "Tenant") {
      if (!newDealDocs.includes("Tenant's Fee Agreement")) {
        newDealDocs.push("Tenant's Fee Agreement");
      }
    }

    // Add "Disclosure of Remuneration" to tenant docs if commission payer is Landlord
    if (CommissionPayer === "Landlord") {
      if (!newTenantDocs.includes("Disclosure of Remuneration")) {
        newTenantDocs.push("Disclosure of Remuneration");
      }
    }

    setDealDocs(newDealDocs);
    setTenantDocs(newTenantDocs);
  };

  const handleLandlordRep = (e) => {
    setLandlordRep(e.target.value);
    if (e.target.value === LandlordRep) {
      return;
    }

    if (e.target.value === "Yes") {
      setListingType("MLS");
      setIsDisclosure("No");
      let newDealDocs = [...DealDocs];
      let newTenantDocs = [...TenantDocs];
      newDealDocs = newDealDocs.filter(
        (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)"
      );
      // Remove fee agreements and remuneration confirmation for non-FRBO listing types
      newDealDocs = newDealDocs.filter(
        (item) =>
          item !== "Landlord's Fee Agreement" &&
          item !== "Tenant's Fee Agreement" &&
          item !== "Confirm Remuneration amount with LA, in writing"
      );

      // Add "Disclosure of Remuneration" to tenant docs if commission payer is Landlord
      if (CommissionPayer === "Landlord") {
        if (!newTenantDocs.includes("Disclosure of Remuneration")) {
          newTenantDocs.push("Disclosure of Remuneration");
        }
      }

      if (newDealDocs.includes("Full REALTOR® LEASED MLS Printout") === true) {
        setDealDocs(newDealDocs);
        setTenantDocs(newTenantDocs);
      } else {
        newDealDocs.push("Full REALTOR® LEASED MLS Printout");
        setDealDocs(newDealDocs);
        setTenantDocs(newTenantDocs);
      }
    }

    if (e.target.value === "No") {
      setTenantRep("Client");
      setListingType("MLS");
      setCommissionPayer("Landlord");
      setIsDisclosure("No");
      setDealDocs(
        DealDocs.filter(
          (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)"
        )
      );
      // Add Full Realtor Printout Statement
      if (!DealDocs.includes("Full REALTOR® LEASED MLS Printout")) {
        setDealDocs((prevDocs) => [
          ...prevDocs,
          "Full REALTOR® LEASED MLS Printout",
        ]);
      }

      setTenantDocs([
        "Disclosure of Representation in Trading Services",
        "Tenant's Agency Exclusive Contract",
        "Privacy Notice & Consent Form",
        "Disclosure of Remuneration",
      ]);
    }
  };

  const handleTenantRep = (e) => {
    setTenantRep(e.target.value);
    if (e.target.value === "Client") {
      setTenantDocs([
        "Disclosure of Representation in Trading Services",
        "Tenant's Agency Exclusive Contract",
        "Privacy Notice & Consent Form",
      ]);
    } else {
      setTenantDocs([
        "Disclosure of Representation in Trading Services",
        "Disclosure of Risks to Unrepresented Parties",
        "Privacy Notice & Consent Form",
      ]);
    }
  };

  const handleCommissionPayer = (e) => {
    setCommissionPayer(e.target.value);

    let newDealDocs = [...DealDocs];
    let newTenantDocs = [...TenantDocs];

    // Remove existing fee agreements and remuneration confirmation when commission payer changes
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !== "Landlord's Fee Agreement" &&
        item !== "Tenant's Fee Agreement" &&
        item !== "Confirm Remuneration amount with LA, in writing"
    );

    // Remove existing "Disclosure of Remuneration" from tenant docs
    newTenantDocs = newTenantDocs.filter(
      (item) => item !== "Disclosure of Remuneration"
    );

    // Add the appropriate fee agreement based on who pays commission for FRBO and Mere Posting
    if (ListingType === "FRBO" || ListingType === "Mere Posting") {
      if (e.target.value === "Landlord") {
        newDealDocs.push("Landlord's Fee Agreement");
      } else if (e.target.value === "Tenant") {
        newDealDocs.push("Tenant's Fee Agreement");
      }
    }

    // Add "Disclosure of Remuneration" to tenant docs if commission payer is Landlord
    if (e.target.value === "Landlord") {
      newTenantDocs.push("Disclosure of Remuneration");

      // Add remuneration confirmation to deal docs for Exclusive listing with Landlord commission payer
      if (ListingType === "Exclusive") {
        if (
          !newDealDocs.includes(
            "Confirm Remuneration amount with LA, in writing"
          )
        ) {
          newDealDocs.push("Confirm Remuneration amount with LA, in writing");
        }
      }
    }

    setDealDocs(newDealDocs);
    setTenantDocs(newTenantDocs);
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 ">
            Do you also represent the Landlord in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleLandlordRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleLandlordRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {LandlordRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Tenant's Representation?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                    value={TenantRep}
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={handleTenantRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="an Unrepresented Party"
                      control={<Radio size="small" onClick={handleTenantRep} />}
                      label="Unrepresented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <div>
                  <FormControlLabel
                    value="MLS"
                    control={<Radio size="small" onClick={setMLS} />}
                    label="MLS"
                  />
                  <FormControlLabel
                    value="Exclusive"
                    control={<Radio size="small" onClick={setExclusive} />}
                    label="Exclusive"
                  />
                </div>

                {LandlordRep !== "Yes" ? (
                  <div>
                    <FormControlLabel
                      value="Mere Posting"
                      control={<Radio size="small" onClick={setMLS} />}
                      label="Mere Posting"
                    />
                    <FormControlLabel
                      value="FRBO"
                      control={<Radio size="small" onClick={handleFRBO} />}
                      label="For Rent By Owner"
                    />
                  </div>
                ) : (
                  ""
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {LandlordRep !== "Yes" ? (
            <>
              <div className="pr-5 pt-5">Who will Pay Commission?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={CommissionPayer}
                  >
                    <FormControlLabel
                      value="Landlord"
                      control={
                        <Radio size="small" onClick={handleCommissionPayer} />
                      }
                      label="Landlord"
                    />
                    <FormControlLabel
                      value="Tenant"
                      control={
                        <Radio size="small" onClick={handleCommissionPayer} />
                      }
                      label="Tenant"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
        </div>

        <div className="pr-5 pt-5">
          Are you or immediate family members leasing this property?
        </div>
        <ThemeProvider theme={theme}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={IsDisclosure}
            >
              <FormControlLabel
                value="Yes"
                control={<Radio size="small" onClick={addDisclosure} />}
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={<Radio size="small" onClick={removeDisclosure} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </ThemeProvider>
      </div>

      {LandlordRep === "Yes" && TenantRep === "Client" ? (
        <BCMustRefer IsMLS={ListingType} />
      ) : (
        <>
          {ListingType === "Mere Posting" || ListingType === "FRBO" ? (
            <ChecklistCard
              province={"BC"}
              CheckListData={TenantDocs}
              CheckListData2={getLandlordDocs()}
              CheckListData3={DealDocs}
              Header={"Lease:"}
              Header2={"Tenant is " + TenantRep}
              Title1="Tenant Documents"
              Title2="Landlord Documents"
              Title3="Deal Documents"
            />
          ) : (
            <ChecklistCard
              province={"BC"}
              CheckListData={TenantDocs}
              CheckListData2={DealDocs}
              Header={"Lease:"}
              Header2={"Tenant is " + TenantRep}
              Title1="Tenant Documents"
              Title2="Deal Documents"
            />
          )}
        </>
      )}

      {LandlordRep === "Yes" &&
      TenantRep === "Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : ListingType === "Mere Posting" || ListingType === "FRBO" ? (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("mere")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "no"
          )}
        />
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("lease")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) => item.category.includes("lease") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("lease") && item.isCommon === "no"
          )}
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("lease") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
